/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

/* eslint-disable jsx-a11y/label-has-associated-control */
import { Field, useFormikContext } from "formik";
import { FC, KeyboardEventHandler, useCallback } from "react";

import getValueByStringPath from "web/utils/page/product/domesticTourism/getValueByStringPath";

import classes from "./selectItem.scss";

interface ISelectItemProps {
  option:
    | string
    | {
        value: string;
        label: string;
        id?: string | undefined;
      };
  closeAction: (event?: React.MouseEvent | React.KeyboardEvent) => void;
  name: string;
  isOpen: boolean;
}

const SelectItem: FC<ISelectItemProps> = ({
  option,
  closeAction,
  name,
  isOpen,
}) => {
  const { values, setFieldValue } =
    useFormikContext<Record<string, string | number>>();
  const currentValue = getValueByStringPath(values, name);
  const isActive =
    currentValue && currentValue === (option as { value: string }).value;
  const clickHandler = useCallback(
    (event: React.MouseEvent<HTMLLabelElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setFieldValue(name, (option as { value: string }).value);
      closeAction(event);
    },
    [closeAction, name, option, setFieldValue]
  );

  const keyDownHandler: KeyboardEventHandler<HTMLLabelElement> = useCallback(
    (event) => {
      if (["Enter", " "].indexOf(event.key) !== -1) {
        event.preventDefault();
        event.stopPropagation();
        setFieldValue(name, (option as { value: string }).value);
        closeAction(event);
      }
    },
    [closeAction, name, option, setFieldValue]
  );

  const classNameRootActive = isActive && classes.rootActive;
  const classNameRoot = classNameRootActive || classes.root;

  return (
    <label
      key={(option as { value: string }).value}
      className={classNameRoot}
      onClick={clickHandler}
      onKeyDown={keyDownHandler}
      tabIndex={isOpen ? 0 : -1}
      role="option"
      aria-selected={!!isActive}
    >
      <Field
        type="radio"
        className="visually-hidden"
        name={name}
        value={(option as { value: string }).value}
        dataT1="select_item_radio"
        tabIndex={-1}
      />
      <span>{(option as { label: string }).label}</span>
    </label>
  );
};

export default SelectItem;
